import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/src/components/ui/accordion";
import { TemplateSelect } from "./TemplateSelect";
import { ProviderSelect } from "./ProviderSelect";
import type { AiModel } from "@/src/types/ai.zod";
import { useTranslation } from "@/src/i18n/client";
import { Template } from "@/src/types/template.zod";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/ui/select";

interface AdvancedSettingsProps {
  selectedTemplate: string;
  onTemplateChange: (value: string) => void;
  availableTemplates: Template[];
  templatesLoading: boolean;
  selectedProvider: string;
  onProviderChange: (value: string) => void;
  availableProviders: AiModel[];
}

export function AdvancedSettings({
  selectedTemplate,
  onTemplateChange,
  availableTemplates,
  templatesLoading,
  selectedProvider,
  onProviderChange,
  availableProviders,
}: AdvancedSettingsProps) {
  const { t } = useTranslation();
  return (
    <Accordion className="w-full relative z-30">
      <AccordionItem value="advanced-settings">
        <AccordionTrigger>{t('homePage.advancedSettings.title')}</AccordionTrigger>
        <AccordionContent className="z-30 relative space-y-4">
          <TemplateSelect
            value={selectedTemplate}
            onValueChange={onTemplateChange}
            templates={availableTemplates}
            isLoading={templatesLoading}
          />
          <ProviderSelect
            value={selectedProvider}
            onValueChange={onProviderChange}
            providers={availableProviders}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
